'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('font-awesome-webpack');

require('@/res/globalStyle.css');

var _tinycon = require('tinycon');

var _tinycon2 = _interopRequireDefault(_tinycon);

var _Welcome = require('@/components/startups/Welcome');

var _Welcome2 = _interopRequireDefault(_Welcome);

var _ZncLogin = require('@/components/startups/ZncLogin');

var _ZncLogin2 = _interopRequireDefault(_ZncLogin);

var _CustomServer = require('@/components/startups/CustomServer');

var _CustomServer2 = _interopRequireDefault(_CustomServer);

var _KiwiBnc = require('@/components/startups/KiwiBnc');

var _KiwiBnc2 = _interopRequireDefault(_KiwiBnc);

var _Personal = require('@/components/startups/Personal');

var _Personal2 = _interopRequireDefault(_Personal);

var _StateBrowser = require('@/components/StateBrowser');

var _StateBrowser2 = _interopRequireDefault(_StateBrowser);

var _AppSettings = require('@/components/AppSettings');

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _Container = require('@/components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _ControlInput = require('@/components/ControlInput');

var _ControlInput2 = _interopRequireDefault(_ControlInput);

var _MediaViewer = require('@/components/MediaViewer');

var _MediaViewer2 = _interopRequireDefault(_MediaViewer);

var _Sidebar = require('@/components/Sidebar');

var _Notifications = require('@/libs/Notifications');

var Notifications = _interopRequireWildcard(_Notifications);

var _bufferTools = require('@/libs/bufferTools');

var bufferTools = _interopRequireWildcard(_bufferTools);

var _ThemeManager = require('@/libs/ThemeManager');

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('App.vue');

exports.default = {
    components: {
        StateBrowser: _StateBrowser2.default,
        Container: _Container2.default,
        ControlInput: _ControlInput2.default,
        MediaViewer: _MediaViewer2.default
    },
    data: function data() {
        return {
            startupComponent: null,
            hasStarted: false,

            stateBrowserDrawOpen: false,

            activeComponent: null,
            activeComponentProps: {},

            fallbackComponent: null,
            fallbackComponentProps: {},
            mediaviewerOpen: false,
            mediaviewerUrl: '',
            mediaviewerComponent: null,
            mediaviewerIframe: false,
            themeUrl: '',
            sidebarState: new _Sidebar.State()
        };
    },

    computed: {
        networks: function networks() {
            return this.$state.networks;
        },
        network: function network() {
            return this.$state.getActiveNetwork();
        },
        buffer: function buffer() {
            return this.$state.getActiveBuffer();
        }
    },
    created: function created() {
        var _this = this;

        this.listenForActiveComponents();
        this.watchForThemes();
        this.initStateBrowser();
        this.initMediaviewer();
        this.configureFavicon();

        document.addEventListener('keydown', function (event) {
            return _this.onKeyDown(event);
        }, false);
        window.addEventListener('focus', function (event) {
            return _this.onFocus(event);
        }, false);
        window.addEventListener('blur', function (event) {
            return _this.onBlur(event);
        }, false);
        window.addEventListener('touchstart', function (event) {
            return _this.onTouchStart(event);
        });
    },
    mounted: function mounted() {
        var startupScreens = {
            welcome: _Welcome2.default,
            customServer: _CustomServer2.default,
            kiwiBnc: _KiwiBnc2.default,
            znc: _ZncLogin2.default,
            personal: _Personal2.default
        };
        var extraStartupScreens = this.$state.getStartups();

        var startupName = this.$state.settings.startupScreen || 'personal';
        var startup = extraStartupScreens[startupName] || startupScreens[startupName];

        if (!startup) {
            _Logger2.default.error('Startup screen "' + startupName + '" does not exist');
        } else {
            this.startupComponent = startup;
        }
        this.trackWindowDimensions();
    },

    methods: {
        startUp: function startUp(opts) {
            log('startUp()');
            if (opts && opts.fallbackComponent) {
                this.fallbackComponent = opts.fallbackComponent;
            }
            if (opts && opts.fallbackComponentProps) {
                this.fallbackComponentProps = opts.fallbackComponentProps;
            }

            if (!this.hasStarted) {
                this.warnOnPageClose();
                Notifications.requestPermission();
                Notifications.listenForNewMessages(this.$state);
            }

            this.hasStarted = true;
        },
        listenForActiveComponents: function listenForActiveComponents() {
            var _this2 = this;

            this.listen(this.$state, 'active.component', function (component, props) {
                _this2.activeComponent = null;
                if (component) {
                    _this2.activeComponentProps = props;
                    _this2.activeComponent = component;
                }
            });
        },
        watchForThemes: function watchForThemes() {
            var _this3 = this;

            var themes = _ThemeManager2.default.instance();
            this.themeUrl = _ThemeManager2.default.themeUrl(themes.currentTheme());
            this.listen(this.$state, 'theme.change', function () {
                _this3.themeUrl = _ThemeManager2.default.themeUrl(themes.currentTheme());
            });
        },
        initStateBrowser: function initStateBrowser() {
            var _this4 = this;

            this.listen(this.$state, 'statebrowser.toggle', function () {
                _this4.stateBrowserDrawOpen = !_this4.stateBrowserDrawOpen;
            });
            this.listen(this.$state, 'statebrowser.show', function () {
                _this4.stateBrowserDrawOpen = true;
            });
            this.listen(this.$state, 'statebrowser.hide', function () {
                _this4.stateBrowserDrawOpen = false;
            });
        },
        initMediaviewer: function initMediaviewer() {
            var _this5 = this;

            this.listen(this.$state, 'mediaviewer.show', function (url) {
                var opts = {};

                if (typeof url === 'string') {
                    opts = { url: url };
                } else {
                    opts = url;
                }

                _this5.mediaviewerUrl = opts.url;
                _this5.mediaviewerComponent = opts.component;
                _this5.mediaviewerIframe = opts.iframe;
                _this5.mediaviewerOpen = true;
            });

            this.listen(this.$state, 'mediaviewer.hide', function () {
                _this5.mediaviewerOpen = false;
            });
        },
        configureFavicon: function configureFavicon() {
            var _this6 = this;

            _tinycon2.default.setOptions({
                width: 7,
                height: 9,
                color: '#ffffff',
                background: '#b32d2d',
                fallback: true
            });

            this.$state.$watch('ui.favicon_counter', function (newVal) {
                if (newVal) {
                    _tinycon2.default.setBubble(newVal);
                } else {
                    _tinycon2.default.reset();
                }
            });

            this.listen(this.$state, 'message.new', function (message) {
                if (!message.isHighlight || message.ignore || _this6.$state.ui.app_has_focus) {
                    return;
                }

                _this6.$state.ui.favicon_counter++;
            });
        },
        trackWindowDimensions: function trackWindowDimensions() {
            var _this7 = this;

            var trackWindowDims = function trackWindowDims() {
                _this7.$state.ui.app_width = _this7.$el.clientWidth;
                _this7.$state.ui.app_height = _this7.$el.clientHeight;
                _this7.$state.ui.is_narrow = _this7.$el.clientWidth <= 769;
            };
            window.addEventListener('resize', trackWindowDims);
            trackWindowDims();
        },
        warnOnPageClose: function warnOnPageClose() {
            var _this8 = this;

            window.onbeforeunload = function () {
                if (_this8.$state.setting('warnOnExit')) {
                    return _this8.$t('window_unload');
                }

                return undefined;
            };
        },
        emitBufferPaste: function emitBufferPaste(event) {
            if (!this.$state.getActiveBuffer() || this.activeComponent !== null) {
                return;
            }

            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement) {
                return;
            }

            this.$state.$emit('buffer.paste', event);
        },
        emitDocumentClick: function emitDocumentClick(event) {
            this.$state.$emit('document.clicked', event);
        },
        onTouchStart: function onTouchStart(event) {
            this.$state.ui.is_touch = true;
        },
        onBlur: function onBlur(event) {
            this.$state.ui.app_has_focus = false;
        },
        onFocus: function onFocus(event) {
            this.$state.ui.app_has_focus = true;
            var buffer = this.$state.getActiveBuffer();
            if (buffer) {
                buffer.markAsRead(true);
            }

            this.$state.ui.favicon_counter = 0;
        },
        onKeyDown: function onKeyDown(event) {
            this.$state.$emit('document.keydown', event);

            var meta = false;

            if (navigator.appVersion.indexOf('Mac') !== -1) {
                meta = event.metaKey;
            } else {
                meta = event.ctrlKey;
            }

            if (meta && event.keyCode === 221) {
                var buffer = bufferTools.getNextBuffer();
                if (buffer) {
                    this.$state.setActiveBuffer(buffer.networkid, buffer.name);
                }
                event.preventDefault();
            } else if (meta && event.keyCode === 219) {
                var _buffer = bufferTools.getPreviousBuffer();
                if (_buffer) {
                    this.$state.setActiveBuffer(_buffer.networkid, _buffer.name);
                }
                event.preventDefault();
            } else if (meta && event.keyCode === 79) {
                this.$state.$emit('active.component', _AppSettings2.default);
                event.preventDefault();
            } else if (meta && event.keyCode === 83) {
                var network = this.$state.getActiveNetwork();
                if (network) {
                    network.showServerBuffer('settings');
                }
                event.preventDefault();
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["App"]
window._kiwi_exports.components.App = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue
// module id = mV8s
// module chunks = 1